import { useCallback } from "react";
const useValidateResetToken = (authImplementation) => {
  return useCallback(
    async (resetToken) => {
      if (authImplementation.validateResetToken) {
        return await authImplementation.validateResetToken(resetToken);
      } else {
        throw new Error(
          `Auth client ${authImplementation.type} does not implement this function`
        );
      }
    },
    [authImplementation]
  );
};
export {
  useValidateResetToken
};
